import lightColors from '../styles/settings/light-colors-export.module.scss';
import darkColors from '../styles/settings/dark-colors-export.module.scss';

export type Color = {
  color: string;
  percent: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const textColors = {
  neutral100: '#ffffff',
  primary: '#ffffff',
  secondary: '#aaaaaa',
  accent: '#aaaaaa',
  negative: '#282828',
  link: '#CDB4E6',
  warning: '#FFF2E2',
  error: '#e50000',
  valid: '#c2e2b6',
  black: '#ffffff',
} as const;
export type TextColorsType = keyof typeof textColors;

export type ColorsType = keyof typeof lightColors;

const Colors = (isDark?: boolean) => {
  const isDarkLocalStorage = localStorage.getItem('darkMode');

  const isDarkMode = isDarkLocalStorage
    ? JSON.parse(isDarkLocalStorage)
    : false;

  return isDark || isDarkMode ? darkColors : lightColors;
};

export const tierColors = {
  bronze: Colors().bronze,
  silver: Colors().silver,
  gold: Colors().gold,
  platinum: Colors().primary200,
} as const;

export default Colors;
